import { Component, Input } from '@angular/core';
import { Observable, Subscription } from 'rxjs/Rx';
import { Store } from '@ngrx/store';

import * as Enum from '../../../dtos/enums';
import { ConfigHelper } from 'app/services/config.helper';

@Component({
    selector: 'start-screen-photo',
    template: require('./start-screen-photo.component.html')
})
export class StartScreenPhotoComponent {
    @Input() stationNumber: number;
    @Input() testTakerPhotoUrl: string;

    _testTakerInfo: PgRendererDto.TestTakerStationAssignment;
    showLocalLanguageNames = false;
    label: string = "STATION";

    @Input()
    set testTakerInfo(value: PgRendererDto.TestTakerStationAssignment){
        this._testTakerInfo = value;
        if ((this._testTakerInfo.FirstNameLocalLanguage != null && this._testTakerInfo.FirstNameLocalLanguage !== '') || (this._testTakerInfo.LastNameLocalLanguage != null && this._testTakerInfo.LastNameLocalLanguage !== '')) {
            this.showLocalLanguageNames = true;
        }
    }

    ngOnInit() {
        if (ConfigHelper.isTdpMode(true)) {
            this.label = "Registration Number";
        }
    }
}



// WEBPACK FOOTER //
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/common/start-screen/start-screen-photo.component.ts